<template lang="pug">
  .page
    section
      .max-width
        .row.center.mobile-vertical
          .col
            .information-wrapper
              img.logo(src="../../assets/images/logo-white-text.svg")

              h1 Sign Up

              p Create your free 14 day trial now to enable your customers to help take your product roadmap to the next level.

              p.footer
                | Already have an account?
                router-link.link(:to="{name: 'login'}") Login!
          .col
            .form-wrapper
              form(@keyup.enter="submit", @submit.prevent="submit")

                //-AlertBox(v-if="error", type="danger", :text="error")

                div.form-field(:class="{error: $v.form.firstName.$error, 'error-required': !$v.form.firstName.required}")
                  label
                    input(placeholder="First Name", type="text", minlength="2", maxlength="25", v-model="$v.form.firstName.$model")

                div.form-field(:class="{error: $v.form.lastName.$error, 'error-required': !$v.form.lastName.required}")
                  label
                    input(placeholder="Last Name", type="text", minlength="2", maxlength="25", v-model="$v.form.lastName.$model")

                div.form-field(:class="{error: $v.form.companyName.$error, 'error-required': !$v.form.companyName.required}")
                  label
                    input(placeholder="Company Name", type="text", minlength="2", maxlength="100", v-model="$v.form.companyName.$model")

                div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
                  label
                    input(placeholder="Work Email Address", v-model="$v.form.email.$model", type="email")
                  .error(v-if="errors.email") {{ errors.email }}

                div.form-field(:class="{error: $v.form.subdomain.$error, 'error-required': !$v.form.subdomain.required}")
                  label
                    input(placeholder="Subdomain", type="text", minlength="2", maxlength="25", v-model="$v.form.subdomain.$model")
                  .error(v-if="errors.subdomain") {{ errors.subdomain }}

                div.form-field(:class="{error: $v.form.password.$error, 'error-required': !$v.form.password.required}")
                  label
                    input(placeholder="Password", minlength="8", v-model="$v.form.password.$model", type="password")

                div.form-field.no-margin
                  button.button.primary-button(type="submit") Submit
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'register',
  components: {
  },
  data () {
    return {
      errors: {},
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        subdomain: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      companyName: {
        required
      },
      email: {
        required
      },
      subdomain: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('user/register', this.form).then(() => {
          this.$router.push({ name: 'Verify' })
        }, response => {
          console.log(response)
          this.errors = response.data.errors
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page
  margin 0 auto
.information-wrapper
  padding $spacing-3
  h1
    color #fff
    font-size 22px
    font-weight 500
    margin-bottom $spacing-3
  .logo
    height 36px
    margin-bottom $spacing-3
    max-width 100%
  p
    color $color-black-lighter
    font-size 18px
    line-height 24px
    &.footer
      //text-align center
      margin-top $spacing-3
      color #fff
      a
        cursor pointer
        margin-left 5px
        text-decoration underline
.form-wrapper
  background-color #fff
  border-radius $border-radius
  margin-left $spacing-3
  padding $spacing-3
  width 400px
  +for_breakpoint(mobile)
    //padding 0
    margin-left 0
    width 100%
    margin-bottom 20px
  
  form
    margin 0 auto
    //max-width 400px
      
+for_breakpoint(mobile)
  .mobile-vertical
    align-items unset
    flex-direction column
</style>
